import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import fastClick from 'fastclick'
import "babel-polyfill";
import report_logo from '@/components/report_logo'
import footer from '@/components/footer'
import board from '@/components/board'
fastClick.attach(document.body)

createApp(App).use(router).
component("reportLogo",report_logo).
component("footerCom",footer).
component("board",board).
mount('#app')
